export const dashboard = {
  'dashboard.title': 'Consultant Dashboard',
  'dashboard.subtitle': 'Manage your client portfolio and track subsidy applications',
  'dashboard.header.title': 'Dashboard',
  'dashboard.header.subtitle': 'What should you do today?',
  'dashboard.header.whatShouldYouDo': 'What should you do today?',
  'dashboard.profiles.title': 'Your Profiles',
  'dashboard.profiles.subtitle': 'Manage your funding profiles and applications',
  'dashboard.profiles.manageProfiles': 'Manage your funding profiles and applications',
  'dashboard.createProfile.title': 'Add a new applicant profile to access more funding opportunities',
  'dashboard.createProfile.newProfile': 'New Profile',
  'dashboard.createProfile.createNewProfile': 'Create New Profile',
  'dashboard.findOpportunities': 'Find Opportunities',
  'dashboard.noProfiles': 'No profiles found',
  'dashboard.noProfilesDesc': 'Start by creating your first profile to discover funding opportunities.',
  'dashboard.createYourFirstProfile': 'Create Your First Profile',
  'dashboard.clientDashboard': 'Client Business Dashboard',
  'dashboard.clientSubtitle': 'Oversee client businesses and monitor their subsidy application progress',
  'dashboard.metrics': 'Consultant Metrics',
  'dashboard.totalClients': 'Total Clients',
  'dashboard.totalSubmissions': 'Total Submissions',
  'dashboard.averageMatchScore': 'Average Match Score',
  'dashboard.sortBy': 'Sort by',
  'dashboard.statusBreakdown': 'Client Status Overview',
  'dashboard.pendingTasks': 'Pending Tasks',
  'dashboard.regionSummary': 'Managed Regions',
  'dashboard.matchPerformance': 'Subsidy Matching Summary',
  'dashboard.clientsInReview': 'Clients In Review',
  'dashboard.newSubsidyMatches': 'New Subsidy Matches',
  'dashboard.pendingDocuments': 'Pending Documents',
  'dashboard.mostActiveRegion': 'Most Active Region',
  'dashboard.filterByStatus': 'Filter by Status',
  'dashboard.filterByRegion': 'Filter by Region',
  'dashboard.alertsAndActions': 'Alerts & Actions',
  'dashboard.clientUpdateLog': 'Client Update Log',
  'dashboard.upcomingDeadlines': 'Upcoming Deadlines',
  'dashboard.reminders': 'Reminders',
  'dashboard.daysLeft': 'days left',
  'dashboard.allClients': 'All Clients',
  'dashboard.onboarding.clientCards': 'Each card shows one of your client businesses',
  'dashboard.onboarding.badges': 'Alerts show missing documents or new subsidy matches',
  'dashboard.onboarding.metrics': 'Quick overview of your entire consultancy performance',
  'dashboard.onboarding.start': 'Start Tour',
} as const;